import { Grid } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { BsGear, BsCardChecklist, BsChevronDown } from 'react-icons/bs'
import { AiOutlineInfoCircle, AiOutlineSwap, AiOutlineCheckCircle } from 'react-icons/ai'
import { BsSearch, BsExclamationLg } from 'react-icons/bs'


import Button from '../../Component/Button'
import { useSelector } from 'react-redux'
import DropDown from '../../Component/DropDown'

import OutsideClickHandler from 'react-outside-click-handler'
import { callWeb3Approval, callWeb3Balance, callWeb3Decimals, callWeb3SetLimit, callWeb3Swap, getStatus, getTransactionHistory, redirectToMetamask, sendTransDetails, switchNetwork, walletConnectHandler } from '../../Utility/helpers'
import Web3 from 'web3'
import { useDispatch } from 'react-redux'
import { API, dark_mode, set_admin, set_balance, set_decimal, set_from, set_limit } from '../../Utility/constants'
import toast from 'react-hot-toast'
import { formatUnits, parseUnits } from "@ethersproject/units";
import Swal from 'sweetalert2'
import classNames from 'classnames'
import backgroundImage from '../../Styles/Assets/backgorund_day.png'
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import TextInput from '../../Component/TextInput'
import StatusDropdown from '../../Component/StatusDropdown.js/index.js'
import metamaskIcon from '../../Styles/Assets/metamask-icon.png'
import { fontWeight } from '@mui/system'


const Status = (props) => {
    let dispatch = useDispatch()

    const mode = useSelector(state => state.mode)
    const networkPairs = useSelector(state => state.networkPairs)
    const acc = useSelector(state => state.acc)
    const networks = useSelector(state => state.networks)
    const [from, setFrom] = useState(Object.keys(networkPairs)[0])

    const [rowData, setRowData] = useState([])
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            name: 'Date',
            selector: row => {
                return (
                    <div>
                        <p style={{ margin: 0, color: '#B2B2B2', fontSize: 14, fontWeight: '700' }}>{row.date}</p>
                        <p style={{ margin: 0, color: '#B2B2B2', fontSize: 14, fontWeight: '700' }}>{row.time}</p>

                    </div>
                )
            },
            width: "150px"

        },
        {
            name: 'Receivable Address',
            selector: row => {
                return (<div >
                    <p style={{ margin: 0 }}>
                        {`${row.recipient_address.slice(
                            0,
                            8
                        )}..${row.recipient_address.slice(-8)}`}
                    </p>
                </div>)
            },
            width: "200px",
            color: '#fff'

        },
        {
            name: 'Amount',
            selector: row => row.amount.toString().match(/^\d+(?:\.\d{0,4})?/).toString(),
            width: "160px"

        },
        {
            name: 'Pair',
            selector: row => row.pair_name,
            width: "160px"

        },

        {
            name: 'TXID',
            selector: row => {
                return (
                    <p style={{ margin: 0 }}>
                        {`${row.request_id.slice(
                            0,
                            8
                        )}..${row.request_id.slice(-8)}`}
                    </p>
                )
            },
            width: "180px"

        },
        {
            name: 'Status',
            width: "150px",

            selector: row => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                        {row.code === "Swap Pending" ? <><BsExclamationLg style={{ color: '#FFBE27', fontSize: 14 }} />
                            <p style={{ paddingLeft: 5, margin: 0, color: '#FFBE27', fontSize: 14, fontWeight: '500' }}>
                                {row.code}</p></> :
                            <>
                                <AiOutlineCheckCircle style={{ color: '#26E439', fontSize: 16 }} />
                                <p style={{ paddingLeft: 5, margin: 0, color: '#26E439', fontSize: 14, fontWeight: '500' }}>
                                    {row.code}
                                </p>
                            </>
                        }

                    </div>
                )
            }
        }

    ];

    const categoryHolder = classNames({
        category_holder: true,
        dark: mode === dark_mode ? true : false
    })

    const loadingState = classNames({
        loading_state: true,
        dark: mode === dark_mode ? true : false
    })

    let userAcc = useSelector(state => {
        return state.acc
    })

    useEffect(() => {
        window.ethereum && window.ethereum.on('chainChanged', (chainId) => {
            if (localStorage.getItem("from")) {
                if (networks[localStorage.getItem("from")].chainID === chainId && acc) {
                    checkApprovalLimit(localStorage.getItem("from"))
                }
            } else {
                if (networks[from].chainID === chainId && acc) {
                    checkApprovalLimit(from)
                }
            }

        });
        if (localStorage.getItem("from")) {
            if (acc && networks[localStorage.getItem("from")].chainID === window.ethereum.chainId) {
                checkApprovalLimit(localStorage.getItem("from"))
            }
        } else {
            if (acc && networks[from].chainID === window.ethereum.chainId) {
                checkApprovalLimit(from)
            }
        }

    }, [acc])

    useEffect(() => {
        if (from in networks) {
            window.web3 = new Web3(window.ethereum)
        }
    }, [from])

    const checkApprovalLimit = async (from) => {
        try {
            if (acc) {
                dispatch({ type: set_balance, payLoad: "" })
                let limit = await callWeb3Approval(networks[from].base_contract, acc, networks[from].cross_chain_contract, from)
                let balance = await callWeb3Balance(acc, from, networks[from].base_contract)
                let dec = await callWeb3Decimals(from, networks[from].base_contract)
                balance = formatUnits(balance, dec)
                limit = formatUnits(limit, dec)
                dispatch({ type: set_balance, payLoad: balance })
                dispatch({ type: set_limit, payLoad: limit })
                dispatch({ type: set_decimal, payLoad: Number(dec) })
                setLoading(false)
            }
        } catch (error) {
            toast.error(error.message)
            setLoading(false)
        }
    }
    useEffect(() => {
        getHistory()
    }, [userAcc])

    const customStyles = {
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                color: mode === dark_mode ? '#f0f0f3' : '#231F20',
                backgroundColor: "transparent",
            },
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px',
                color: mode === dark_mode ? '#f0f0f3' : '#231F20',
                backgroundColor: "transparent"
            },
        },
    };
    const getHistory = async () => {
        let tableHeader = []
        setLoading(true)
    }

    const onSearch = async (val) => {
        await getStatus({ request_id: val }).then(res => {

            setRowData(res.data.data)
        })
    }

    const ExpandedComponent = ({ data }) => {
        let splitStatus = data.status.split('.')
        let splitFee = data.feeInStream.split(' ')
        let splitAmount = data.amount.split(' ')


        return (<div className='expanded_table'>
            <p style={{ paddingTop: 10, paddingRight: 20, paddingLeft: 10, fontSize: 14, color: data.code === 'Swap Pending' ? '#FFBE27' : '#26E439' }}>{splitStatus[0]} <br /> {splitStatus[1]}</p>
            <table >
                <tr >
                    <th style={{ paddingLeft: 80, paddingRight: 50, color: '#B2B2B2', width: 250 }}>Amount</th>
                    <th style={{ paddingRight: 50, color: '#B2B2B2', width: 200 }}>Fee</th>
                    <th style={{ paddingRight: 50, color: '#B2B2B2', width: 150 }}>Network</th>
                    <th style={{ paddingRight: 50, color: '#B2B2B2', width: 150 }}>Created</th>
                </tr>
                <tr>
                    <td style={{ fontSize: 14, paddingLeft: 80, paddingRight: 50 }}>{splitAmount[0].toString().match(/^\d+(?:\.\d{0,4})?/).toString()} {splitAmount[1]}</td>
                    <td style={{ fontSize: 14 }}>{splitFee[0].toString().match(/^\d+(?:\.\d{0,4})?/).toString()} {splitFee[1]}</td>
                    <td style={{ fontSize: 14 }}>{data.pair_name}</td>
                    <td style={{ fontSize: 14 }}>{data.date}</td>
                </tr>
            </table></div>)

    };

    return (
        <div className='swap_body'>
            <div className='swap_bg' style={{
                // backgroundImage: window.innerWidth < 768 ? "" : `url(${backgroundImage})`,
                height: "500px",
                width: '100%',
                position: 'absolute',
                bottom: 0,
                opacity: 0.05,
            }}>
            </div>
            <div className='status_body'>
                <div className='request'>
                    <div className='request_title'>
                        <h3>Status</h3>
                    </div>
                    <div className='search_nav_holder'>
                        <TextInput onChange={(val) => onSearch(val)} width="100%" type="text" color={mode === dark_mode ? "#fff" : "black"} icon={<BsSearch color={"#B2B2B2"} size={30}></BsSearch>} placeholder='Search' ></TextInput>
                    </div>
                </div>
                <div className={categoryHolder}>
                    {rowData.length > 0 ? <DataTable
                        persistTableHead={true}
                        columns={columns}
                        data={rowData.length > 0 ? rowData : []}
                        customStyles={customStyles}
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                    />
                        : <div className={loadingState}>
                            <div className='loading_title'>
                                <p>No Data Found.</p>
                                <p>Please Search With Transaction ID</p>
                            </div>
                        </div>}

                </div>
            </div>
        </div >
    )

}
export default Status;
